<template>
  <div :class="$route.meta.color == 'white' ? 'wht topBar' : 'topBar'">
    <div class="topbar-w">
      <a @click="goPage('/')">
        <img class="logo" src="@/assets/images/logo.png" alt="logo"/>
      </a>
      <div class="menus">
        <div class="menus-w">
          <a class="item">
            <span @click="goPage('/visit')" :class="$language.text('zh','en')">{{
                $language.text('参观', 'Visit')
              }}</span>
            <div :class="'sub-menus ' + ($route.meta.color == 'white' ? 'no-bg' : '')">
              <a @click="goPage('/visit?p=open')" class="item">
                <span class="zh">开放时间</span>
                <span class="en">Opening Hours</span>
              </a>
              <a @click="goPage('/visit?p=arrive')" class="item">
                <span class="zh">如何到达</span>
                <span class="en">Getting Here</span>
              </a>
              <a @click="goPage('/visit?p=ticket')" class="item">
                <span class="zh">优待&免票政策</span>
                <span class="en">Concessionary & Free Admission Policy</span>
              </a>
              <a @click="goPage('/visit?p=yearly')" class="item">
                <span class="zh">美术馆年票</span>
                <span class="en">Annual Pass</span>
              </a>
              <a @click="goPage('/visit?p=service')" class="item">
                <span class="zh">展馆服务</span>
                <span class="en">Services</span>
              </a>
              <a @click="goPage('/visit?p=guide')" class="item">
                <span class="zh">展览导览</span>
                <span class="en">Guided Tours</span>
              </a>
              <a @click="goPage('/visit?p=notice')" class="item">
                <span class="zh">参观须知</span>
                <span class="en">Visiting Notice</span>
              </a>
            </div>
          </a>
          <a class="item">
            <span @click="goPage('/exhibitions')"
                  :class="$language.text('zh','en')">{{ $language.text('展览', 'Exhibition') }}</span>
            <div :class="'sub-menus ' + ($route.meta.color == 'white' ? 'no-bg' : '')">
              <a @click="goPage('/exhibitions?p=current')" class="item">
                <span class="zh">当前展览</span>
                <span class="en">Current</span>
              </a>
              <a @click="goPage('/exhibitions?p=past')" class="item">
                <span class="zh">过往展览</span>
                <span class="en">Past</span>
              </a>
              <a @click="goPage('/exhibitions?p=coming')" class="item">
                <span class="zh">即将展出</span>
                <span class="en">Upcoming</span>
              </a>
            </div>
          </a>
          <a @click="goPage('/education')" class="item">
            <span class="zh">公共活动</span>
            <span class="en">Public Event</span>
          </a>
          <a class="item">
            <span @click="goPage('/public_art')" :class="$language.text('zh','en')">{{
                $language.text('公共艺术', 'Public Art')
              }}</span>
            <div :class="'sub-menus ' + ($route.meta.color == 'white' ? 'no-bg' : '')">
              <a @click="goPage('/public_art?p=permanent')" class="item">
                <span class="zh">永久陈列艺术品</span>
                <span class="en">Permanent Site-specific Projects</span>
              </a>
              <a @click="goPage('/public_art?p=year')" class="item">
                <span class="zh">年度艺术项目</span>
                <span class="en">Annual Project</span>
              </a>
            </div>
          </a>
          <a @click="goPage('/library')" class="item">
            <span class="zh">图书馆</span>
            <span class="en">Library</span>
          </a>
          <a @click="goPage('/residency')" class="item">
            <span class="zh">驻留</span>
            <span class="en">Residency</span>
          </a>
          <a @click="goPage('/archives')" class="item">
            <span class="zh">档案馆</span>
            <span class="en">Archives</span>
          </a>
        </div>
      </div>
      <div class="ops">
        <div class="item can-open display-pc not-display-600">
          <div :class="'item-opens open-fontsize '+ (opOpen.fontSize ? 'open' : '')">
            <div class="op-item" @click="changeFontSize('font-s')">S</div>
            <div class="op-item" @click="changeFontSize('font-m')">M</div>
            <div class="op-item" @click="changeFontSize('font-l')">L</div>
          </div>
          <div class="og-w" v-if="!opOpen.fontSize" @click="openFontSize()">
            <img class="og" src="@/assets/images/icon-font-size-blk.png" alt="adjust font size"/>
          </div>
        </div>
        <div class="item can-open display-pc not-display-600">
          <div :class="'item-opens open-color '+ (opOpen.colorMode ? 'open' : '')">
            <div class="op-item" @click="changeColorMode('light')">
              <img src="@/assets/images/icon-day-blk.png" alt="change mode"/>
              <span class="zh">白天</span>
              <span class="en">Day</span>
            </div>
            <div class="op-item" @click="changeColorMode('dark')">
              <img src="@/assets/images/icon-night-blk.png" alt="change mode"/>
              <span class="zh">夜晚</span>
              <span class="en">Night</span>
            </div>
            <div class="op-item" @click="changeColorMode('eco')">
              <img src="@/assets/images/icon-eco-blk.png" alt="change mode"/>
              <span class="zh">节能</span>
              <span class="en">Eco</span>
            </div>
          </div>
          <div class="og-w" v-if="!opOpen.colorMode" @click="openColorMode()">
            <img class="og" src="@/assets/images/icon-mode-blk.png" alt="change mode"/>
          </div>
        </div>
        <div class="item can-open display-pc not-display-600">
          <div :class="'item-opens open-lang '+ (opOpen.lang ? 'open' : '')">
            <div class="op-item" @click="changeLanguage('zh')">简体中文 / 中国</div>
            <div class="op-item" @click="changeLanguage('en')">English / EN</div>
          </div>
          <div class="og-w" v-if="!opOpen.lang" @click="openLanguage()">
            <img class="og" src="@/assets/images/icon-lang-blk.png" alt="change language"/>
          </div>
        </div>
        <div class="item display-pc not-display-600">
          <div class="og-w" @click="openMenu">
            <img class="og" src="@/assets/images/icon-menu-opener-blk.png" alt="open menu"/>
          </div>
        </div>
        <div class="item not-display-pc display-600">
          <div class="og-w" @click="openMenuResp">
            <img class="og" src="@/assets/images/icon-menu-opener-blk.png" alt="open menu"/>
          </div>
        </div>
      </div>
    </div>
    <div :class="'shadow' + (showFloatMenu ? ' show' : '')">
      <div class="shadow-w">
        <div class="menu-shadow">
          <div class="btn-close" @click="closeMenu">
            <img src="@/assets/images/icon-close-blk.png" alt="close menu"/>
          </div>
          <div class="tp">
            <a @click="goPage('/visit')" class="item">
              <span class="zh">参观</span>
              <span class="en">Visit</span>
            </a>
            <a @click="goPage('/exhibitions')" class="item">
              <span class="zh">展览</span>
              <span class="en">Exhibition</span>
            </a>
            <a @click="goPage('/education')" class="item">
              <span class="zh">公共活动</span>
              <span class="en">Public Event</span>
            </a>
            <a @click="goPage('/public_art')" class="item">
              <span class="zh">公共艺术</span>
              <span class="en">Public Art</span>
            </a>
            <a @click="goPage('/library')" class="item">
              <span class="zh">图书馆</span>
              <span class="en">Library</span>
            </a>
            <a @click="goPage('/residency')" class="item">
              <span class="zh">驻留</span>
              <span class="en">Residency</span>
            </a>
            <a @click="goPage('/archives')" class="item">
              <span class="zh">档案馆</span>
              <span class="en">Archives</span>
            </a>
            <div class="l-navs nav-top">
              <div class="ftt">
                <span class="zh">加入</span>
                <span class="en">Join</span>
              </div>
              <a @click="goPage('/join')" class="fstt">
                <span class="zh">工作机会</span>
                <span class="en">Job Opportunities</span>
              </a>
              <a @click="goPage('/join')" class="fstt">
                <span class="zh">志愿者</span>
                <span class="en">Volunteers</span>
              </a>
            </div>
            <div class="l-navs nav-bottom">
              <div class="ftt">
                <span class="zh">关于</span>
                <span class="en">About</span>
              </div>
              <a @click="goPage('/about')" class="fstt">
                <span class="zh">天目里美术馆</span>
                <span class="en">BY ART MATTERS</span>
              </a>
              <a @click="goPage('/media')" class="fstt">
                <span class="zh">媒体中心</span>
                <span class="en">Media Center</span>
              </a>
            </div>
            <div class="r-navs nav-top">
              <div class="ftt">
                <span class="zh">支持</span>
                <span class="en">Support</span>
              </div>
              <a @click="goPage('/join')" class="fstt">
                <span class="zh">合作与支持</span>
                <span class="en">Support & Collaboration</span>
              </a>
              <a @click="goPage('/support')" class="fstt">
                <span class="zh">展览赞助</span>
                <span class="en">Exhibition Sponsorship</span>
              </a>
              <a @click="goPage('/support')" class="fstt">
                <span class="zh">赞助回馈</span>
                <span class="en">Sponsorship Rewards</span>
              </a>
            </div>
            <div class="r-navs nav-bottom">
              <div class="ftt">
                <span class="zh">语种</span>
                <span class="en">Language</span>
              </div>
              <a class="fstt" @click="changeLanguage('zh')">简体中文 / 中国
              </a>
              <a class="fstt" @click="changeLanguage('en')">English / EN
              </a>
            </div>
          </div>
          <div class="bp">
            <p class="owner">
              <span class="zh">BY ART MATTERS 天目里美术馆</span>
              <span class="en">BY ART MATTERS</span>
            </p>
            <p class="addr">
              <span class="zh">
                杭州市西湖区天目山路398号天目里1#天目里美术馆<br/>
                info@byartmatters.com
              </span>
              <span class="en">
                #1 OōEli, 398 Tianmushan Road, Xihu District, Hangzhou, China
                <br/>
                info@byartmatters.com
              </span>
            </p>
            <img class="xcx-qrcode" src="@/assets/images/qrcode20250429.jpg" alt="wechat qrcode"/>
            <p class="xcx-hint">
              <span class="zh">目里小程序</span>
              <span class="en">OōEli Mini Program</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div :class="'shadow' + (showFloatMenuResp ? ' show' : '')">
      <div class="shadow-w">
        <div class="menu-resp-shadow">
          <div class="btn-close" @click="closeMenuResp">
            <img src="@/assets/images/icon-close-blk.png" alt="close menu"/>
          </div>
          <div class="topbar-w">
            <a @click="goPage('/')">
              <img class="logo" src="@/assets/images/logo.png" alt="logo"/>
            </a>
          </div>
          <div class="menus-w">
            <div :class="'item ' + (this.respMenuOpenStatus['visit'] ? 'open': '')">
              <span @click="openRespSubMenu('visit')"
                    :class="$language.text('zh','en')">{{ $language.text('参观', 'Visit') }}</span>
              <div class="sub-menus">
                <a @click="goPage('/visit?p=open')" class="item">
                  <span class="zh">开放时间</span>
                  <span class="en">Opening Hours</span>
                </a>
                <a @click="goPage('/visit?p=arrive')" class="item">
                  <span class="zh">如何到达</span>
                  <span class="en">Getting Here</span>
                </a>
                <a @click="goPage('/visit?p=ticket')" class="item">
                  <span class="zh">优待&免票政策</span>
                  <span class="en">Concessionary & Free Admission Policy</span>
                </a>
                <a @click="goPage('/visit?p=yearly')" class="item">
                  <span class="zh">美术馆年票</span>
                  <span class="en">Annual Pass</span>
                </a>
                <a @click="goPage('/visit?p=service')" class="item">
                  <span class="zh">展馆服务</span>
                  <span class="en">Services</span>
                </a>
                <a @click="goPage('/visit?p=guide')" class="item">
                  <span class="zh">展览导览</span>
                  <span class="en">Guided Tours</span>
                </a>
                <a @click="goPage('/visit?p=notice')" class="item">
                  <span class="zh">参观须知</span>
                  <span class="en">Visiting Notice</span>
                </a>
              </div>
            </div>
            <div :class="'item ' + (this.respMenuOpenStatus['exhibitions'] ? 'open': '')">
              <span @click="openRespSubMenu('exhibitions')"
                    :class="$language.text('zh','en')">{{ $language.text('展览', 'Exhibitions') }}</span>
              <div class="sub-menus">
                <a @click="goPage('/exhibitions?p=current')" class="item">
                  <span class="zh">当前展览</span>
                  <span class="en">Current</span>
                </a>
                <a @click="goPage('/exhibitions?p=past')" class="item">
                  <span class="zh">过往展览</span>
                  <span class="en">Past</span>
                </a>
                <a @click="goPage('/exhibitions?p=coming')" class="item">
                  <span class="zh">即将展出</span>
                  <span class="en">Upcoming</span>
                </a>
              </div>
            </div>
            <a @click="goPage('/education')" class="item">
              <span class="zh">公共活动</span>
              <span class="en">Public Event</span>
            </a>
            <div :class="'item ' + (this.respMenuOpenStatus['public_art'] ? 'open': '')">
              <span @click="openRespSubMenu('public_art')"
                    :class="$language.text('zh','en')">{{ $language.text('公共艺术', 'Public Art') }}</span>
              <div class="sub-menus">
                <a @click="goPage('/public_art?p=permanent')" class="item">
                  <span class="zh">永久陈列艺术品</span>
                  <span class="en">Permanent Site-specific Projects</span>
                </a>
                <a @click="goPage('/public_art?p=year')" class="item">
                  <span class="zh">年度艺术项目</span>
                  <span class="en">Annual Project</span>
                </a>
              </div>
            </div>
            <a @click="goPage('/library')" class="item">
              <span class="zh">图书馆</span>
              <span class="en">Library</span>
            </a>
            <a @click="goPage('/residency')" class="item">
              <span class="zh">驻留</span>
              <span class="en">Residency</span>
            </a>
            <a @click="goPage('/archives')" class="item">
              <span class="zh">档案馆</span>
              <span class="en">Archives</span>
            </a>
            <div :class="'item ' + (this.respMenuOpenStatus['join'] ? 'open': '')">
              <span @click="openRespSubMenu('join')" :class="$language.text('zh','en')">{{
                  $language.text('加入', 'Join')
                }}</span>
              <div class="sub-menus">
                <a @click="goPage('/join?p=cooperation')" class="item">
                  <span class="zh">合作与支持</span>
                  <span class="en">Support & Collaboration</span>
                </a>
                <a @click="goPage('/join?p=jobs')" class="item">
                  <span class="zh">工作机会</span>
                  <span class="en">Job Opportunities</span>
                </a>
                <a @click="goPage('/join?p=volunteer')" class="item">
                  <span class="zh">志愿者</span>
                  <span class="en">Volunteers</span>
                </a>
              </div>
            </div>
            <div :class="'item ' + (this.respMenuOpenStatus['support'] ? 'open': '')">
              <span @click="openRespSubMenu('support')" :class="$language.text('zh','en')">{{
                  $language.text('支持', 'Support')
                }}</span>
              <div class="sub-menus">
                <a @click="goPage('/support')" class="item">
                  <span class="zh">展览赞助</span>
                  <span class="en">Exhibition Sponsorship</span>
                </a>
                <a @click="goPage('/support')" class="item">
                  <span class="zh">赞助回馈</span>
                  <span class="en">Sponsorship Rewards</span>
                </a>
              </div>
            </div>
            <div :class="'item ' + (this.respMenuOpenStatus['about'] ? 'open': '')">
              <span @click="openRespSubMenu('about')" :class="$language.text('zh','en')">{{
                  $language.text('关于', '')
                }}</span>
              <div class="sub-menus">
                <a @click="goPage('/about')" class="item">
                  <span class="zh">天目里美术馆</span>
                  <span class="en">BY ART MATTERS</span>
                </a>
                <a @click="goPage('/media')" class="item">
                  <span class="zh">媒体中心</span>
                  <span class="en">Media Center</span>
                </a>
              </div>
            </div>
            <div class="ops">
              <div class="item can-open ">
                <div :class="'item-opens open-fontsize '+ (opOpen.fontSize ? 'open' : '')">
                  <div class="op-item" @click="changeFontSize('font-s')">S</div>
                  <div class="op-item" @click="changeFontSize('font-m')">M</div>
                  <div class="op-item" @click="changeFontSize('font-l')">L</div>
                </div>
                <div class="og-w" v-if="!opOpen.fontSize" @click="openFontSize()">
                  <img class="og" src="@/assets/images/icon-font-size-blk.png" alt="adjust font size"/>
                </div>
              </div>
              <div class="item can-open">
                <div :class="'item-opens open-color '+ (opOpen.colorMode ? 'open' : '')">
                  <div class="op-item" @click="changeColorMode('light')">
                    <img src="@/assets/images/icon-day-blk.png" alt="change mode"/>
                    <span class="zh">白天</span>
                    <span class="en">Day</span>
                  </div>
                  <div class="op-item" @click="changeColorMode('dark')">
                    <img src="@/assets/images/icon-night-blk.png" alt="change mode"/>
                    <span class="zh">夜晚</span>
                    <span class="en">Night</span>
                  </div>
                  <div class="op-item" @click="changeColorMode('eco')">
                    <img src="@/assets/images/icon-eco-blk.png" alt="change mode"/>
                    <span class="zh">节能</span>
                    <span class="en">Eco</span>
                  </div>
                </div>
                <div class="og-w" v-if="!opOpen.colorMode" @click="openColorMode()">
                  <img class="og" src="@/assets/images/icon-mode-blk.png" alt="change mode"/>
                </div>
              </div>
              <div class="item can-open">
                <div :class="'item-opens open-lang '+ (opOpen.lang ? 'open' : '')">
                  <div class="op-item" @click="changeLanguage('zh')">简体中文 / 中国</div>
                  <div class="op-item" @click="changeLanguage('en')">English / EN</div>
                </div>
                <div class="og-w" v-if="!opOpen.lang" @click="openLanguage()">
                  <img class="og" src="@/assets/images/icon-lang-blk.png" alt="change language"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "topBarComponent",
  components: {},
  data() {
    return {
      showFloatMenu: false,
      showFloatMenuResp: false,
      respMenuOpenStatus: {
        'visit': false,
        'exhibitions': false,
        'public_art': false,
        'join': false,
        'support': false,
        'about': false
      },
      opOpen: {
        'fontSize': false,
        'colorMode': false,
        'lang': false
      }
    }
  },
  mounted() {
    console.log(this.$color)
  },
  methods: {
    openMenu: function () {
      this.showFloatMenu = true;
      this.showFloatMenuResp = false;
    },
    closeMenu: function () {
      this.showFloatMenu = false;
    },
    openMenuResp() {
      this.showFloatMenuResp = true;
      this.showFloatMenu = false;
    },
    closeMenuResp() {
      this.showFloatMenuResp = false;
    },
    openRespSubMenu(tab) {
      let status = this.respMenuOpenStatus[tab];
      if (status) {
        this.respMenuOpenStatus = {
          'visit': false,
          'exhibitions': false,
          'public_art': false,
          'join': false,
          'support': false,
          'about': false
        }
      } else {
        let statusMap = {
          'visit': false,
          'exhibitions': false,
          'public_art': false,
          'join': false,
          'support': false,
          'about': false
        }
        statusMap[tab] = true
        this.respMenuOpenStatus = statusMap
      }
    },
    goPage(path) {
      this.$router.push(path);
      console.log(path);
      this.showFloatMenu = false;
      this.showFloatMenuResp = false;
      this.respMenuOpenStatus = {
        'visit': false,
        'exhibitions': false,
        'public_art': false,
        'join': false,
        'support': false,
        'about': false
      }
    },
    openLanguage() {
      this.opOpen = {
        'fontSize': false,
        'colorMode': false,
        'lang': true
      }
    },
    changeLanguage(lang) {
      this.$language.set(lang);
      this.opOpen.lang = false;
      this.showFloatMenuResp = false;
    },
    openFontSize() {
      this.opOpen = {
        'fontSize': true,
        'colorMode': false,
        'lang': false
      }
    },
    changeFontSize(size) {
      document.getElementsByTagName('body')[0].classList.remove('font-s', 'font-m', 'font-l');
      document.getElementsByTagName('body')[0].classList.add(size);
      this.opOpen.fontSize = false;
      this.showFloatMenuResp = false;
    },
    openColorMode() {
      this.opOpen = {
        'fontSize': false,
        'colorMode': true,
        'lang': false
      }
    },
    changeColorMode(mode) {
      document.getElementsByTagName('body')[0].classList.remove('light', 'dark', 'eco');
      document.getElementsByTagName('body')[0].classList.add(mode);
      this.opOpen.colorMode = false;
      this.showFloatMenuResp = false;
    },
  }
};
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/topBar/index.vue